import template from './component.tpl.html';
import './controller';

angular
    .module('festzelt-os.dashboard')
    .component('dashboardDefault', {
        bindings: {

        },
        controller: 'DashboardDefaultController',
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/components/default/component.js